export const BUNDLE_CTA_TEST_ID = {
  checkoutCta: 'checkout-cta',
};
